// ABOUTME: The deliberate-entry confirmation gate shared by the parent and child surfaces (Issue #1939).
// ABOUTME: Dismissing it ("Not yet") is pure UI — no fetch, so the crossing is never mutated.

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

interface CrossingEntryDialogProps {
  open: boolean;
  crossingId: number;
  onDismiss: () => void;
  onConfirm: (crossingId: number) => void;
}

export default function CrossingEntryDialog({ open, crossingId, onDismiss, onConfirm }: CrossingEntryDialogProps) {
  return (
    <Dialog open={open} onClose={onDismiss} aria-labelledby="crossing-entry-title">
      <DialogTitle id="crossing-entry-title">Ready to start this crossing?</DialogTitle>
      <DialogContent />
      <DialogActions>
        <Button onClick={onDismiss}>Not yet</Button>
        <Button variant="contained" onClick={() => onConfirm(crossingId)}>Start</Button>
      </DialogActions>
    </Dialog>
  );
}
